import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import $ from 'jquery'
import * as Cookies from 'js-cookie'

$.urlParam = function(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
    window.location.search
  )
  return results !== null ? results[1] || 0 : false
}

Vue.use(Vuex)

let plugins = []
if (process.env.VUE_APP_PERSISTED == 'YES') {
  plugins.push(
    createPersistedState({
      key: 'people',
      //storage: window.sessionStorage
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value),
        removeItem: key => Cookies.remove(key)
      }
    })
  )
}

export default new Vuex.Store({
  state: {
    graphqlTicket: '',
    graphqlTicketExpires: new Date(),
    username: '',
    personId: '',
    role: '',
    checkingLogin: false,
    ready: false,
    graphqlProps: {
      endpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
      pagination: process.env.VUE_APP_GRAPHQL_PAGINATION,
      lookupCache: process.env.VUE_APP_LOOKUP_CACHE
    }
  },
  plugins: plugins,
  mutations: {
    getLogin: function() {
      this.commit('checkLogin')
    },
    logout: function() {
      this.commit('doLogout')
    },
    doLogout: function(state) {
      state.graphqlTicket = ''
      state.personId = ''
      state.username = ''
      state.role = ''
      state.graphqlTicketExpires = new Date()
      Cookies.remove('graphql.sid', { path: '/' })
      window.location.href = process.env.VUE_APP_CAS_ENDPOINT + '/logout'
    },
    checkLogin: function(state) {
      if (
        state.graphqlTicket == '' ||
        new Date(state.graphqlTicketExpires) <= new Date()
      ) {
        state.checkingLogin = true
        if ($.urlParam('ticket') == '') {
          Cookies.set('hash', location.hash.replace(/^#/, ''))
          location.href = `${
            process.env.VUE_APP_CAS_ENDPOINT
          }/login?service=${encodeURIComponent(
            location.href
              .replace(/([?&]?)ticket=[^&#]*(.*)/, '$1$2')
              .split('#')[0]
              .replace(/[?&]*$/, '')
          )}`
        } else {
          Cookies.remove('graphql.sid', { path: '/' })
          /*
          location.hash =
            location.hash.replace(/^#/, '') == ''
              ? localStorage.hash || ''
              : location.hash.replace(/^#/, '')
          */
          $.ajax({
            url: `${process.env.VUE_APP_GRAPHQL_ENDPOINT}/authenticate`,
            type: 'GET',
            data: {
              service: location.href
                .replace(/([?&]?)ticket=[^&#]*(.*)/, '$1$2')
                .split('#')[0]
                .replace(/[?&]*$/, ''),
              ticket: $.urlParam('ticket')
            },
            success: function(response) {
              state.graphqlTicket = response.split(':')[0]
              state.username = response.split(':')[1]
              state.personId = response.split(':')[2]
              state.role = response.split(':')[3]
              state.graphqlTicketExpires = new Date(0)
              state.graphqlTicketExpires.setUTCSeconds(response.split(':')[4])
              state.checkingLogin = false
              state.ready = true
            },
            error: function() {
              Cookies.set('hash', location.hash.replace(/^#/, ''))
              location.href = `${
                process.env.VUE_APP_CAS_ENDPOINT
              }/login?service=${encodeURIComponent(
                location.href
                  .replace(/([?&]?)ticket=[^&#]*(.*)/, '$1$2')
                  .split('#')[0]
                  .replace(/[?&]*$/, '')
              )}`
            }
          })
        }
      } else {
        state.ready = true
      }
    }
  }
})
